import { loadTwitchGame } from "./twitchCompact";

export async function loadTwitchStreamerDetails(gameId, period = "7d") {
  if (!/^[A-Za-z0-9_-]{1,80}$/.test(String(gameId ?? ""))) throw new Error("A Twitch game ID is required.");
  if (!["now", "1d", "7d"].includes(period)) throw new Error("Unsupported Twitch streamer period.");
  const record = await loadTwitchGame(`streamers/${period}`, gameId);
  if (record && (!Array.isArray(record.streamers) || record.period !== period)) throw new Error("Invalid per-game Twitch streamers.");
  return record;
}
